<script lang="ts">
    export let value: string;
</script>

<span class="preformatted-text">{value}</span>

<style lang="less">
    .preformatted-text {
        white-space: pre
    }
</style>